import { ReactNode } from 'react';

import { PortalLinkContext } from '~/components/PortalLink';
import { SelectedEmployeeContextRootProvider } from '~/components/SelectedEmployee';
import { useAuthentication } from '~/data/user/useAuthentication';

export type LibraryComponentProviders_OnLegacyNavigation = {
  onLegacyNavigate?: (navigationProps: unknown) => void;
};

type PropsType = LibraryComponentProviders_OnLegacyNavigation & {
  children?: ReactNode;
};

export const LibraryComponentProviders = (props: PropsType) => {
  const { onLegacyNavigate, children } = props;

  const { isAuthenticated, userDetails } = useAuthentication();

  return isAuthenticated && !!userDetails ? (
    <PortalLinkContext.Provider
      value={{ isRouteLinksEnabled: false, onLegacyNavigate }}
    >
      <SelectedEmployeeContextRootProvider>
        {children}
      </SelectedEmployeeContextRootProvider>
    </PortalLinkContext.Provider>
  ) : (
    <></>
  );
};
